import Vue from 'vue'
import FBPixel from '@/vendor/FBPixel'

Vue.use(FBPixel, {
  env: process.env.NODE_ENV,
  scriptSrc: '//connect.facebook.net/en_US/fbevents.js',
  debug: process.env.NODE_ENV !== 'production',
  pixelIds: ['655272716532097', '1719944272190689']
})
